export enum QUERY_KEYS {
  VERIFY_LOGIN = 'VERIFY_LOGIN',
}

export default QUERY_KEYS
